import React from "react";
import styled, { css } from "styled-components";

import { Text } from "../Text";
import { Icon } from "../Icon";
import { Icons } from "../Icon/types";

interface Props {
  clearFilters: () => void;
}

const FiltersClear: React.ReactFCWithChildren<Props> = props => {
  return (
    <Wrapper onClick={() => props.clearFilters()}>
      <Text fontSize="h5">
        Clear filters
      </Text>

      <Icon
        size={20}
        $fillColor="primaryLight"
        icon={Icons.CLOSECIRCLE}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacing.padding.md} 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    span {
      padding-right: ${theme.spacing.padding.sm};
    }
  `}
`;

export default FiltersClear;
